<template>
  <div class="event-type-edit" v-loading="loading">
    <div class="both-sides page-title">
      <div>
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <span>{{ isNew ? '新建流程模版' : '编辑流程模版' }}</span>
      </div>
      <el-button type="primary" :loading="saving" @click="save">保存模版</el-button>
    </div>

    <el-card shadow="never">
      <div class="section-title">基本信息</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="模版名称" prop="name"><el-input v-model="form.name"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="执行团队"><el-select v-model="form.dealerId" clearable filterable style="width:100%"><el-option v-for="item in dealers" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="默认联系人"><el-input v-model="form.contact"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="联系电话"><el-input v-model="form.contactPhone"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="活动方"><el-input v-model="form.host"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="默认活动时间"><el-date-picker v-model="form.eventTime" type="datetime" style="width:100%" placeholder="可留空，创建订单时再填写"/></el-form-item></el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <div class="section-title with-action"><span>流程与步骤</span><el-button type="primary" plain size="small" icon="el-icon-plus" @click="addGroup">添加流程</el-button></div>
      <div v-if="!form.groups.length" class="empty-block">尚未添加流程</div>
      <div v-for="(group, groupIndex) in form.groups" :key="group._key" class="group-block">
        <div class="both-sides group-header">
          <strong>流程 {{ groupIndex + 1 }}</strong>
          <el-button type="text" class="danger-action" @click="removeGroup(groupIndex)">删除流程</el-button>
        </div>
        <el-row :gutter="16">
          <el-col :span="10"><el-input v-model="group.name" placeholder="流程名称"/></el-col>
          <el-col :span="7"><el-checkbox v-model="group.isRandom">步骤乱序执行</el-checkbox></el-col>
          <el-col :span="7"><el-checkbox v-model="group.imageRequired">完成时必须有图片</el-checkbox></el-col>
        </el-row>
        <div class="steps-header"><span>步骤</span><el-button type="text" icon="el-icon-plus" @click="addStep(groupIndex)">添加步骤</el-button></div>
        <div v-for="(step, stepIndex) in group.steps" :key="step._key" class="step-row">
          <span class="step-index">{{ stepIndex + 1 }}</span>
          <el-input v-model="step.name" placeholder="步骤名称"/>
          <el-button type="text" class="danger-action" @click="removeStep(groupIndex, stepIndex)">删除</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <div class="section-title with-action"><span>客户反馈问题</span><el-button type="primary" plain size="small" icon="el-icon-plus" @click="addFeedback">添加问题</el-button></div>
      <div v-if="!form.feedbacks.length" class="empty-block">尚未添加反馈问题</div>
      <div v-for="(item, index) in form.feedbacks" :key="item._key" class="feedback-row">
        <span class="step-index">{{ index + 1 }}</span>
        <el-input v-model="item.question" placeholder="反馈问题"/>
        <el-select v-model="item.type" style="width:130px">
          <el-option label="文本" value="input"/><el-option label="评分" value="rate"/>
          <el-option label="单选" value="radio"/><el-option label="多选" value="checkbox"/>
        </el-select>
        <el-input v-if="item.type === 'radio' || item.type === 'checkbox'" v-model="item.arguments" placeholder="选项，每行一个"/>
        <el-button type="text" class="danger-action" @click="removeFeedback(index)">删除</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {eventtype} from "@/api/eventtype";
import {user} from "@/api/user";

let keySeed = 0;
const key = () => `tmp-${Date.now()}-${++keySeed}`;
const toIso = value => value ? new Date(value).toISOString() : null;

export default {
  name: "EventTypeEdit",
  data() {
    return {
      form: {id: null, name: "", contact: "", contactPhone: "", host: "", eventTime: null, dealerId: null, groups: [], feedbacks: []},
      dealers: [], loading: false, saving: false,
      rules: {name: [{required: true, message: "请输入模版名称", trigger: "blur"}]},
    };
  },
  computed: {isNew() { return !this.form.id; }},
  created() {
    user.listAllDealer().then(res => { this.dealers = res.data || []; });
    if (this.$route.query.id) {
      this.form.id = Number(this.$route.query.id);
      this.loadDetail();
    }
  },
  methods: {
    loadDetail() {
      this.loading = true;
      eventtype.detail(this.form.id).then(res => {
        const data = res.data || {};
        this.form = {
          id: data.id, name: data.name || "", contact: data.contact || "", contactPhone: data.contactPhone || "",
          host: data.host || "", eventTime: data.eventTime ? new Date(data.eventTime) : null, dealerId: data.dealerId || null,
          groups: (data.groups || []).map(group => ({...group, _key: key(), isRandom: !!group.isRandom, imageRequired: !!group.imageRequired, steps: (group.steps || []).map(step => ({...step, _key: key()}))})),
          feedbacks: (data.feedbacks || []).map(item => ({...item, _key: key(), type: item.type || "input"})),
        };
      }).finally(() => { this.loading = false; });
    },
    goBack() { this.$router.push("/event-type"); },
    addGroup() { this.form.groups.push({_key: key(), name: "", isRandom: false, imageRequired: false, steps: []}); },
    removeGroup(index) { this.form.groups.splice(index, 1); },
    addStep(groupIndex) { this.form.groups[groupIndex].steps.push({_key: key(), name: ""}); },
    removeStep(groupIndex, stepIndex) { this.form.groups[groupIndex].steps.splice(stepIndex, 1); },
    addFeedback() { this.form.feedbacks.push({_key: key(), question: "", type: "input", arguments: ""}); },
    removeFeedback(index) { this.form.feedbacks.splice(index, 1); },
    validateNested() {
      if (this.form.groups.some(group => !group.name.trim() || group.steps.some(step => !step.name.trim()))) {
        this.$message.warning("请完整填写流程和步骤名称"); return false;
      }
      if (this.form.feedbacks.some(item => !item.question.trim())) {
        this.$message.warning("请完整填写反馈问题"); return false;
      }
      return true;
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid || !this.validateNested()) return;
        const payload = {
          name: this.form.name.trim(), contact: this.form.contact, contactPhone: this.form.contactPhone,
          host: this.form.host, eventTime: toIso(this.form.eventTime), dealerId: this.form.dealerId || null,
          groups: this.form.groups.map(group => ({name: group.name.trim(), isRandom: group.isRandom, imageRequired: group.imageRequired, steps: group.steps.map(step => ({name: step.name.trim()}))})),
          feedbacks: this.form.feedbacks.map(item => ({question: item.question.trim(), type: item.type, arguments: item.arguments || ""})),
        };
        if (!this.isNew) payload.id = this.form.id;
        this.saving = true;
        (this.isNew ? eventtype.create(payload) : eventtype.update(payload)).then(() => {
          this.$message.success("保存成功"); this.goBack();
        }).finally(() => { this.saving = false; });
      });
    },
  },
};
</script>

<style scoped>
.event-type-edit .el-card { margin-bottom: 16px; }
.page-title { margin-bottom: 16px; font-size: 18px; font-weight: 600; align-items: center; }
.page-title div { display: flex; align-items: center; gap: 12px; }
.section-title { font-weight: 600; margin-bottom: 16px; }
.with-action, .group-header { display: flex; justify-content: space-between; align-items: center; }
.group-block { border: 1px solid #ebeef5; background: #fafafa; border-radius: 4px; padding: 14px; margin-bottom: 12px; }
.steps-header { display: flex; justify-content: space-between; align-items: center; margin: 12px 0 6px; }
.step-row, .feedback-row { display: flex; align-items: center; gap: 10px; margin: 8px 0; }
.step-index { width: 24px; text-align: center; color: #909399; flex: none; }
.empty-block { padding: 20px; border: 1px dashed #dcdfe6; text-align: center; color: #909399; }
.danger-action { color: #f56c6c; }
</style>
